// extracted by mini-css-extract-plugin
module.exports = {"cookieBanner":"cookie-banner-module--cookieBanner--1_PTs"};